import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const Modal = ({ isOpen, onClose, children }) => {
  // Prevent scrolling on the body when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    // Cleanup function to restore scrolling when modal closes
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  
  // Don't render anything if the modal isn't open
  if (!isOpen) return null;
  
  // Create the modal JSX
  const modalContent = (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="modal-container" 
        onClick={e => e.stopPropagation()} // Prevent clicks inside from closing
      >
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>
  );
  
  // Use createPortal to render this JSX into the modal-root DOM node
  return ReactDOM.createPortal(
    modalContent,
    document.getElementById('modal-root') // This targets the div we added to index.html
  );
};

export default Modal;